// Keep PostHog's Conversations ("Support") bubble alive across Turbo navigations.
//
// PostHog's conversations.js mounts the widget container (#ph-conversations-widget-container)
// into <body> exactly once and never re-creates it — unlike Surveys, which re-render on a
// 1s interval. Turbo Drive replaces the whole <body> on every navigation, which destroys the
// bubble and leaves it gone until a full page reload.
//
// Fix: as soon as PostHog injects the widget, relocate it out of <body> onto <html> so Turbo's
// body swap can't touch it. PostHog still finds the container via document.getElementById
// (document-wide, not body-scoped), so it reuses our node and never creates a duplicate. The
// widget is position:fixed, so moving it out of <body> has no visual effect.
const WIDGET_ID = "ph-conversations-widget-container"

function liftWidgetOutOfBody() {
    const el = document.getElementById(WIDGET_ID)
    if (el && el.parentElement !== document.documentElement) {
        document.documentElement.appendChild(el)
    }
    return Boolean(el)
}

// PostHog injects the widget asynchronously after load, so watch for it and relocate it once.
const observer = new MutationObserver(() => {
    if (liftWidgetOutOfBody()) observer.disconnect()
})
observer.observe(document.documentElement, { childList: true, subtree: true })

// Safety net: relocate again after Turbo navigations in case it ever lands back inside <body>.
document.addEventListener("turbo:load", liftWidgetOutOfBody)
